import api from "../apiClient";

// Brands this tenant runs (backend: accounts/views_brands.py → /api/brands/).
// {brands: ["solveary", "stop-pest"], show_filter: true}. show_filter is false for a
// tenant with fewer than two brands, and callers render no filter at all then.
export const getTenantBrands = () => api.get("/brands/");
